export const sources = {
	avif: "__VITE_ASSET__Die0gvR1__ 174w",
	webp: "__VITE_ASSET__x9_s4lvU__ 174w"
};
export const img = {
	src: "__VITE_ASSET__DdGcqukB__",
	w: 174,
	h: 247
};
export default {
	sources: sources,
	img: img
};
